module.exports = __webpack_public_path__ + "assets/flags/ie.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ie.svg
// module id = 503
// module chunks = 0